import { toast } from 'react-toastify'

export const useNotification = () => toast
